import {ToastOptions, toastState} from './toast-store';

export function toast(
  message: any | string,
  opts?: ToastOptions
) {
  toastState().add(message, opts);
}

toast.danger = (message: any | string, opts?: ToastOptions) => {
  toastState().add(message, {...opts, type: 'danger'});
};

toast.positive = (message: any | string, opts?: ToastOptions) => {
  toastState().add(message, {...opts, type: 'positive'});
};

toast.loading = (message: any | string, opts?: ToastOptions) => {
  toastState().add(message, {...opts, type: 'loading'});
};
